BX.namespace('BX.Chili.Comments.CommentsList');

/**
 * @param {Object} options
 * @param {Element} options.container
 *
 * @return  {BX.Chili.Comments.CommentsList}
 * */
BX.Chili.Comments.CommentsList = function (options){

    if(!new.target){
        return new BX.Chili.Comments.CommentsList(options);
    }

    let self = this;

    this.options = options;

    this.container = this.options.container;
    this.list = this.options.container.querySelector('.chili-page-comments-list');
    this.componentId = this.container.dataset.componentId;

    function Pagination () {

        if(!new.target){
            return new Pagination();
        }

        /**@var {Element}*/
        this.listContainer = null;

        /**@var {Element}*/
        this.container = null;

        this.currentPage = 1;

        this.lastPage = 1;

        /**
         * Список загруженных страниц пагинации
         * @type {Object<number, Page>}
         */
        this.pages = {};

        /**
         * Описывает данные страницы пагинации
         *
         * @param {Object} options
         * @param {Element} options.pageElement Элемент, который содержит в себе контент страницы
         * @param {Number} options.pageNumber Номер страницы в пагинации
         * */
        function Page (options) {
            if (!new.target) {
                return new Page(options);
            }

            const visibleClassName = 'component-content--visible';

            let statesMap = new Map([['loading', "loading"], ['complete', "complete"]]);

            this.state = statesMap.get('loading');
            this.pageNumber = options.pageNumber;
            this.pageElement = options.pageElement;

            /**@param {'loading'|'complete'} state*/
            this.setState = (state) => {
                if (statesMap.has(state)) {
                    this.state = statesMap.get(state);
                }
            }

            this.setVisible = () => {
                if (this.pageElement && !this.pageElement?.classList?.contains(visibleClassName)) {
                    this.pageElement.classList.add(visibleClassName);
                }
            }

            this.setInVisible = () => {
                if (this.pageElement && this.pageElement?.classList?.contains(visibleClassName)) {
                    this.pageElement.classList.remove(visibleClassName);
                }
            }
        }

        this.updatePaginationContent = (paginationContent) => {
            if (this.container) {
                this.container.innerHTML = paginationContent.innerHTML;
            } else {
                this.container.append(paginationContent);
                this.registerPaginationHandlers();
            }

            this.lastPage = this.normalizePage(this.container.dataset.lastPage)
        };

        this.registerPaginationHandlers = () => {

            // Установка обработчиков событий для элементов пагинации

            if (self.container.dataset.handlersRegistered === 'false') {

                if (this.container) {
                    this.container.addEventListener('click', (event) => {
                        ;(async (event) => {

                            // Обработка клика по номеру страницы
                            let button = event.target.closest('.red-page-number');

                            if (button) {
                                let page = button.querySelector('[data-page]')?.dataset.page;
                                await self.goToPage(page);
                                self.currentPage = page;
                            }

                            // Обработка клика "Показать еще"
                            let showMoreButton = event.target.closest('.chili-page-comments-show-more-btn');

                            if (showMoreButton) {
                                await self.showMorePage(showMoreButton.dataset.page);
                            }
                        })(event);
                    });

                    this.listContainer.dataset.handlersRegistered = 'true';
                }
            }
        };

        this.normalizePage = (page) => {
            page = parseInt(page);

            if(isNaN(page) || page < 1)
            {
                page = 1;
            }

            return page;
        };

        /**
         * Убирает видимость со всех страниц пагинации
         * @param {Number} except - исключает страницу с этим номером из обработки
         * */
        this.setInvisibleAllPages = (except) => {

            except = this.normalizePage(except);

            for(let key in this.pages){
                if(parseInt(key) !== except){
                    this.pages[key]?.setInVisible();
                }
            }
        }

        /**
         * Описывает данные страницы пагинации
         *
         * @param {Number} page Номер страницы в пагинации
         * @param {Element} element Элемент, который содержит в себе контент страницы
         * */
        this.addPage = (page, element) => {

            let paginationPage = new Page({
                pageElement: element,
                pageNumber: page
            });

            paginationPage.setState('complete');
            this.pages[page] = paginationPage;
        };

        /**
         * Открывает и показывает определенную страницу пагинации
         *
         * @param {Number} page
         * @param {boolean} preserveVisible не прятать видимые страницы
         * */
        this.showPage = (page, preserveVisible) => {
            page = this.normalizePage(page);

            if(!preserveVisible){
                self.pagination.setInvisibleAllPages(page);
            }

            self.pagination.pages[page]?.setVisible();

            self.pagination.currentPage = page;

            this.container.querySelectorAll('.red-page-number button').forEach((element)=>{
                element.disabled = false;
            });

            let currentButton = this.container.querySelector(`.red-page-number button[data-page="${page}"]`);

            if(currentButton){
                currentButton.disabled = true;
            }

            let showMoreButton =  this.container.querySelector('.chili-page-comments-show-more-btn');

            if(showMoreButton){
                if(page === this.lastPage){
                    showMoreButton.disabled = true;
                }
                else{
                    showMoreButton.disabled = false;
                    showMoreButton.dataset.page = page + 1;
                }
            }
        }

        this.clearPages = () => {
            for(const key in this.pages){
                this.pages[key].pageElement.remove();
            }

            this.pages = {};
            this.currentPage = 1;
            this.lastPage = 1;
        }

        let init = () => {
            this.listContainer = self.container;
            this.container = this.listContainer.querySelector('.chili-page-comments-pagination-container');
            this.lastPage = this.normalizePage(this.container.dataset.lastPage);
            this.registerPaginationHandlers();
        }

        init();
    }

    this.pagination = new Pagination();

    this.loadCommentsPage =  async (page) =>
    {

        page = this.pagination.normalizePage(page);

        return BX.ajax
            .runComponentAction(
                "chililab:page.comments.list",
                "getPage",
                {
                    mode: "class",
                    data: {
                        pageNum: page,
                        url: self.container.dataset.url,
                        componentId: self.container.dataset.componentId,
                    },
                }
            );
    }

    /**
     * Переход на определенную страницу.
     * Все остальные страницы скрываются
     *
     * @param {Number} page
     * */
    this.goToPage = async (page) => {
        page = this.pagination.normalizePage(page);

        // Что-то делаем только для нового номера страницы
        if(self.pagination.currentPage !== page){

            if(self.pagination.pages[page]){
                self.pagination.showPage(page);
            }
            else{
                // загружаем страницу перед показом
                try {
                    let response = await self.loadCommentsPage(page);

                    if(response.status  === 'success'){
                        const parser = new DOMParser();
                        let resultDocument = parser.parseFromString(response.data.html, 'text/html');
                        let newContent = resultDocument.querySelector('.component-content');

                        self.list.append(newContent);
                        self.pagination.addPage(page, newContent);
                        self.pagination.showPage(page);

                        let newPaginationContent = resultDocument.querySelector('.chili-page-comments-pagination-container');

                        if(newPaginationContent){
                            self.pagination.updatePaginationContent(newPaginationContent);
                        }

                    }
                    else{
                        throw new Error(response.errors)
                    }
                }
                catch (error){
                    console.error(error);
                }
            }

        }

    }

    /**
     * Показывает определенную страницу в добавление к остальным показанным страницам
     *
     * @param {Number} page
     * */
    this.showMorePage = async (page) => {
        page = self.pagination.normalizePage(page);

        if(self.pagination.pages[page]){
            // страница уже загружена
            self.pagination.showPage(page, true);
        }
        else {
            // загружаем страницу перед показом
            try {
                let response = await this.loadCommentsPage(page);

                if(response.status  === 'success'){
                    const parser = new DOMParser();
                    let resultDocument = parser.parseFromString(response.data.html, 'text/html');
                    let newContent = resultDocument.querySelector('.component-content');

                    self.pagination.addPage(page, newContent)
                    this.list.append(newContent);
                    self.pagination.showPage(page, true);

                    let newPaginationContent = resultDocument.querySelector('.chili-page-comments-pagination-container');

                    if(newPaginationContent){
                        self.pagination.updatePaginationContent(newPaginationContent);
                    }

                }
                else{
                    throw new Error(response.errors)
                }
            }
            catch (error){
                console.error(error);
            }
        }
    }

    /**
     * Перезагружает страницу. Удаляет из кеша все остальные страницы. Обновляет пагинацию.
     * Рекомендуется при добавлении/удалении комментариев, т.к. именно в этот момент пагинация меняется
     *
     * @param {Number} page
     * */
    this.reloadPage = async (page) => {

        page = self.pagination.normalizePage(page);

        try {
            let response = await this.loadCommentsPage(page);

            if(response.status  === 'success'){
                const parser = new DOMParser();
                let resultDocument = parser.parseFromString(response.data.html, 'text/html');
                let newContent = resultDocument.querySelector('.component-content') ?? '';

                this.pagination.clearPages();

                this.pagination.addPage(page, newContent);

                this.list.append(newContent);
                this.pagination.showPage(page);

                let newPaginationContent = resultDocument.querySelector('.chili-page-comments-pagination-container');

                if(newPaginationContent){
                    this.pagination.updatePaginationContent(newPaginationContent);
                }

            }
            else{
                throw new Error(response.errors)
            }
        }
        catch (error){
            console.error(error);
        }

    };

    ;(()=>{
        this.list.querySelectorAll('.component-content').forEach((element)=>{
            let page =  element.dataset.page;
            this.pagination.addPage(page, element);
        })
    })();

}
